import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { StrategicProcurementComponent } from './strategic-procurement/strategic-procurement.component';
import { IndirectMaterialDetailComponent } from './indirect-material-detail/indirect-material-detail.component';
const routes: Routes = [
  {path: '', component: LandingPageComponent  },
  {path: 'products', component:StrategicProcurementComponent},
  {
    path: 'product/:id',
    component: IndirectMaterialDetailComponent,
  },
  {path: 'checkout', component:CheckoutComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule { }
